// The design is a 1920-wide Figma frame. A value expressed in those pixels
// scales with the viewport and is capped at its Figma size from 1920 up.
// 1920 / 100 = 19.2, so `px / 19.2` is the matching vw figure.
export function fluidPx(px) {
  return `min(${px}px, ${(px / 19.2).toFixed(4)}vw)`;
}
